import { Component, input, output } from '@angular/core';
import { LowerCasePipe, NgClass } from '@angular/common';
import { SpinnerComponent } from '../spinner/spinner.component';

@Component({
    selector: 'juyo-button',
    styleUrls: ['./button.scss'],
    imports: [NgClass, LowerCasePipe, SpinnerComponent],
    template: `
        <button
            class="button"
            [disabled]="disabled()"
            [ngClass]="buttonType() | lowercase"
            [class.is-loading]="isLoading()"
            [class.disabled]="disabled()"
            [class.inversed]="inversed()"
            [class.full-width]="useFullWidth()"
            [title]="title()"
            [style.height.px]="heightInPx()"
            [style.width.px]="useFullWidth() ? null : widthInPx()"
            (click)="!disabled() && !isLoading() && onClick()"
        >
            @if (!isLoading()) {
                <span class="label">
                    <ng-content></ng-content>
                </span>
            } @else {
                <juyo-spinner></juyo-spinner>
            }
        </button>
    `,
})
export class ButtonComponent {
    public title = input<string>('');
    public buttonType = input<ButtonType>(ButtonType.PURPLE);
    public disabled = input<boolean>(false);
    public inversed = input<boolean>(false);
    public isLoading = input<boolean>(false);
    public heightInPx = input<40 | 30>(40);
    public widthInPx = input<number | null>(null);
    public useFullWidth = input<boolean>(false);

    public clicked = output<void>();

    public onClick(): void {
        this.clicked.emit();
    }
}

export enum ButtonType {
    BLUE = 'BLUE',
    PURPLE = 'PURPLE',
    ORANGE = 'ORANGE',
    TRANSPARENT = 'TRANSPARENT',
    // SURFACE = 'SURFACE',
    // BASE = 'BASE',
    // RED = 'RED',
    // GREEN = 'GREEN',
    // DEFAULT = 'DEFAULT',
}
